import { render, staticRenderFns } from "./ClientInsuaranceCard.vue?vue&type=template&id=02d2899c&"
import script from "./ClientInsuaranceCard.vue?vue&type=script&lang=ts&"
export * from "./ClientInsuaranceCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports